import * as React from 'react';
import Box from '@mui/material/Box';
import Slider from '@mui/material/Slider';
import InfoIcon from '@mui/icons-material/Info';
import Tooltip from '@mui/material/Tooltip';


const marksLag = [
  { value: 0, label: '-0.4' },
  { value: 20, label: '-0.2' },
  { value: 40, label: '0' },
  { value: 60, label: '0.2' },
  { value: 80, label: '0.4' },
  { value: 100, label: '0.6' },
];

const minDistance = 20;

export default function DiscreteSliderMarks({ setLagSliderValue, compareColour, sliderTitle }) {
  const wrapperStyle = { width: 400, margin: 50 };

  const [value, setValue] = React.useState([0, 100]);
  var lagValue = [0,0]
  const handleChange = (event, newValue, activeThumb) => {

      //setValue(newValue);
      if(newValue[0] > 100){
          newValue[0] = 100;
          //setValue(newValue)
      }
      if (activeThumb === 0) {
          setValue([Math.min(newValue[0], value[1] - minDistance), value[1]]);
          newValue=[Math.min(newValue[0], value[1] - minDistance), value[1]]

        } else {
          setValue([value[0], Math.max(newValue[1], value[0] + minDistance)]);
         // newValue=[value[0], Math.max(newValue[1], value[0] + minDistance)]

        }
    
      lagValue = newValue

        switch (lagValue[0]) {
          case 0:  lagValue[0] = -0.4;
                  break;
          case 20:  lagValue[0] = -0.2;
                  break;
          case 40:  lagValue[0] = 0;
                  break;
          case 60:  lagValue[0] = 0.2;
                  break;
          case 80:  lagValue[0] = 0.4;
                  break;
          case 100:  lagValue[0] = 0.6;
                  break;
          }

      switch (lagValue[1]) {
        case 0:  lagValue[1] = -0.4;
          break;
        case 20:  lagValue[1] = -0.2;
            break;
        case 40:  lagValue[1] = 0;
            break;
        case 60:  lagValue[1] = 0.2;
            break;
        case 80:  lagValue[1] = 0.4;
            break;
        case 100:  lagValue[1] = 0.6;
            break;
      }

      setLagSliderValue(lagValue);
  };
  return (
    <div style={wrapperStyle}>
      <h3 className="widgetLgTitle">
        {sliderTitle}
        <Tooltip title="The range of lag values to run the experiment on.">
          <InfoIcon color="primary"> </InfoIcon>
        </Tooltip>
      </h3>
      <Box sx={{ width: 500 }}>
        <Slider
          aria-label="Custom marks"
          value={value}
          defaultValue={0}
          step={null}
          marks={marksLag}
          onChange={handleChange}
          disableSwap
          color={compareColour}
          valueLabelFormat={(x) => x.toFixed(1)}
          getAriaLabel={(index) => (index === 0 ? 'Minimum' : 'Maximum')}
        />
      </Box>
    </div>
  )
}